import { computed, onBeforeUnmount, type Ref, watch } from "vue";
import type { Bubble } from "./bubble";

/** O que o `spawn_agent` em segundo plano devolve ao Ben — ver `mission.tools.ts` no servidor. */
const STARTED = /^\[started in background, id ([^\]\s]+)\]/;

/** Os ids dos subagentes que o Ben soltou nesta thread e cujo resultado ainda não voltou. */
export function pendingBackgroundAgents(bubbles: readonly Bubble[]): string[] {
	const started = bubbles.flatMap((b) =>
		(b.steps ?? []).flatMap((s) => {
			const id = s.tool === "spawn_agent" ? s.output?.match(STARTED)?.[1] : undefined;
			return id ? [id] : [];
		}),
	);
	const back = bubbles.filter((b) => b.role === "agent").map((b) => b.text);
	return started.filter((id) => !back.some((text) => text.includes(`Background agent ${id} `)));
}

/**
 * O BEN ACORDA SEM NINGUÉM PEDIR (28/10).
 *
 * Quando um subagente em segundo plano acaba e o Ben já tinha encerrado, o
 * servidor abre um turno dele sobre o resultado. Ninguém nesta tela o pediu, então
 * ninguém se liga a ele — a não ser isto: enquanto houver subagente pendente e
 * nenhum turno na tela, procura o turno em voo a cada poucos segundos.
 */
export function useBackgroundAgents(deps: {
	bubbles: Ref<Bubble[]>;
	streaming: Ref<boolean>;
	resume: () => Promise<void>;
}): void {
	const waiting = computed(
		() => !deps.streaming.value && pendingBackgroundAgents(deps.bubbles.value).length > 0,
	);
	let timer: ReturnType<typeof setInterval> | null = null;
	const stop = (): void => {
		if (timer) clearInterval(timer);
		timer = null;
	};
	watch(
		waiting,
		(on) => {
			stop();
			if (on) timer = setInterval(() => void deps.resume(), 5_000);
		},
		{ immediate: true },
	);
	onBeforeUnmount(stop);
}
